var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 9,
    y: 9,
    fill: "#343337",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.963 16.134c.141.96-.25 1.9-.765 2.566-.552.714-1.502 1.266-2.423 1.237-.168-.92.262-1.866.786-2.503.575-.702 1.56-1.241 2.402-1.3Zm2.766 13.512c.475-.727.652-1.094 1.021-1.916-2.68-1.02-3.11-4.83-.457-6.293-.81-1.015-1.947-1.603-3.02-1.603-.773 0-1.303.202-1.785.385-.401.153-.77.293-1.217.293-.484 0-.912-.154-1.36-.314-.494-.177-1.01-.362-1.652-.362-1.205 0-2.487.736-3.3 1.994-1.143 1.772-.948 5.104.905 7.942.662 1.016 1.547 2.157 2.705 2.167.48.005.8-.139 1.146-.294.395-.177.826-.37 1.57-.374.75-.005 1.173.19 1.564.37.337.156.65.3 1.126.295 1.158-.01 2.092-1.274 2.754-2.29Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.912d48f25838df231b8adda2119dfb07.svg";
export { ForwardRef as ReactComponent };